module.exports = __webpack_public_path__ + "img/pilpel_yes.1d2f69ef.png";